import React, { Component } from 'react';

import i18n from 'i18n-react';
import { APIHandler, ContentHeader, Image, SharingPopup } from 'C4';
import { renderToString } from 'react-dom/server';

export default class ShowRoomView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      europe: [
        550, 641, 534, 552, 553, 554, 555, 561, 556, 562, 557, 564, 541, 539,
        538, 569, 570, 573, 577, 578, 579, 580, 581, 582, 583, 584, 585, 586,
        589, 590, 636, 637, 537, 559, 540, 592, 605, 606, 565, 599, 600, 614,
        615, 616, 617, 618, 619, 620, 621, 622, 624, 625, 627, 628, 629, 630,
        632, 607, 608, 609, 610, 611, 612, 594, 595, 596,
      ],
      middleEast: [633],
      africa: [593],
      northAmerica: [
        574, 587, 597, 601, 603, 634, 638, 639, 640, 542, 535, 536, 626, 563,
      ],
      caribbean: [631, 572, 588, 623, 635],
      latinAmerica: [571, 591, 598, 602, 604, 613, 560, 558],
      europeBooths: [],
      africaBooths: [],
      latinAmericaBooths: [],
      northAmericaBooths: [],
      caribbeanBooths: [],
      middleEastBooths: [],
    };
  }

  componentDidMount() {
    this.loadBooths();
  }

  loadBooths() {
    const {
      africa,
      europe,
      middleEast,
      northAmerica,
      caribbean,
      latinAmerica,
    } = this.state;
    APIHandler.getBooths(europe).then((booths) => {
      this.setState({ europeBooths: booths.items });
    });
    APIHandler.getBooths(middleEast).then((booths) => {
      this.setState({ middleEastBooths: booths.items });
    });
    APIHandler.getBooths(northAmerica).then((booths) => {
      this.setState({ northAmericaBooths: booths.items });
    });
    APIHandler.getBooths(caribbean).then((booths) => {
      this.setState({ caribbeanBooths: booths.items });
    });
    APIHandler.getBooths(latinAmerica).then((booths) => {
      this.setState({ latinAmericaBooths: booths.items });
    });
    APIHandler.getBooths(africa).then((booths) => {
      this.setState({ africaBooths: booths.items });
    });
  }

  render() {
    const {
      europeBooths,
      latinAmericaBooths,
      northAmericaBooths,
      middleEastBooths,
      caribbeanBooths,
      africaBooths,
    } = this.state;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['thumbs', 'share', 'close'],
      share: {
        tpl: renderToString(<SharingPopup url="" />),
      },
    };

    return (
      <div className="contentContainer">
        <ContentHeader
          header={i18n.translate('nav.showRoom')}
          subtitle={i18n.translate('pageDescriptions.showRoom')}
        />
        <div className="showRoom__Container">
          <div className="showRoom__Grid">
            <h1>
              Europe
              <hr />
            </h1>
            {europeBooths &&
              Object.values(europeBooths).map((booth, i, arr) => (
                <React.Fragment>
                  {booth.headerImages[0] && (
                    <React.Fragment>
                      {i === 0 && <h2>{booth.country}</h2>}
                      {i > 0 && arr[i].country !== arr[i - 1].country && (
                        <h2>{booth.country}</h2>
                      )}
                      <div
                        className="item-holder"
                        data-src={`https://travproconnect.com/profile/${booth.id}`}
                        data-type="iframe"
                        data-fancybox={booth.id}
                        dataOptions={JSON.stringify(fancyOptions)}
                        data-fancybox-trigger={booth.id}
                      >
                        <img
                          className="logo"
                          src={`${booth.icon.replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=200`}
                          alt={booth.propertyName}
                        />
                        <img
                          src={`${booth.headerImages[0].replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=300`}
                          alt={booth.propertyName}
                        />
                        <div className="content">{booth.propertyName}</div>
                        <div className="view">View Showcase &gt;</div>
                        <div className="clear" />
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}

            <h1>
              North America
              <hr />
            </h1>
            {northAmericaBooths &&
              Object.values(northAmericaBooths).map((booth, i, arr) => (
                <React.Fragment>
                  {booth.headerImages[0] && (
                    <React.Fragment>
                      {i === 0 && <h2>{booth.country}</h2>}
                      {i > 0 && arr[i].country !== arr[i - 1].country && (
                        <h2>{booth.country}</h2>
                      )}
                      <div
                        className="item-holder"
                        data-src={`https://travproconnect.com/profile/${booth.id}`}
                        data-type="iframe"
                        data-fancybox={booth.id}
                        dataOptions={JSON.stringify(fancyOptions)}
                        data-fancybox-trigger={booth.id}
                      >
                        <img
                          className="logo"
                          src={`${booth.icon.replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=200`}
                          alt={booth.propertyName}
                        />
                        <img
                          src={`${booth.headerImages[0].replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=300`}
                          alt={booth.propertyName}
                        />
                        <div className="content">{booth.propertyName}</div>
                        <div className="view">View Showcase &gt;</div>
                        <div className="clear" />
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}

            <h1>
              Latin America
              <hr />
            </h1>
            {latinAmericaBooths &&
              Object.values(latinAmericaBooths).map((booth, i, arr) => (
                <React.Fragment>
                  {booth.headerImages[0] && (
                    <React.Fragment>
                      {i === 0 && <h2>{booth.country}</h2>}
                      {i > 0 && arr[i].country !== arr[i - 1].country && (
                        <h2>{booth.country}</h2>
                      )}
                      <div
                        className="item-holder"
                        data-src={`https://travproconnect.com/profile/${booth.id}`}
                        data-type="iframe"
                        data-fancybox={booth.id}
                        dataOptions={JSON.stringify(fancyOptions)}
                        data-fancybox-trigger={booth.id}
                      >
                        <img
                          className="logo"
                          src={`${booth.icon.replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=200`}
                          alt={booth.propertyName}
                        />
                        <img
                          src={`${booth.headerImages[0].replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=300`}
                          alt={booth.propertyName}
                        />
                        <div className="content">{booth.propertyName}</div>
                        <div className="view">View Showcase &gt;</div>
                        <div className="clear" />
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}

            <h1>
              Caribbean
              <hr />
            </h1>
            {caribbeanBooths &&
              Object.values(caribbeanBooths).map((booth, i, arr) => (
                <React.Fragment>
                  {booth.headerImages[0] && (
                    <React.Fragment>
                      {i === 0 && <h2>{booth.country}</h2>}
                      {i > 0 && arr[i].country !== arr[i - 1].country && (
                        <h2>{booth.country}</h2>
                      )}
                      <div
                        className="item-holder"
                        data-src={`https://travproconnect.com/profile/${booth.id}`}
                        data-type="iframe"
                        data-fancybox={booth.id}
                        dataOptions={JSON.stringify(fancyOptions)}
                        data-fancybox-trigger={booth.id}
                      >
                        <img
                          className="logo"
                          src={`${booth.icon.replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=200`}
                          alt={booth.propertyName}
                        />
                        <img
                          src={`${booth.headerImages[0].replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=300`}
                          alt={booth.propertyName}
                        />
                        <div className="content">{booth.propertyName}</div>
                        <div className="view">View Showcase &gt;</div>
                        <div className="clear" />
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}

            <h1>
              Africa
              <hr />
            </h1>
            {africaBooths &&
              Object.values(africaBooths).map((booth, i, arr) => (
                <React.Fragment>
                  {booth.headerImages[0] && (
                    <React.Fragment>
                      {i === 0 && <h2>{booth.country}</h2>}
                      {i > 0 && arr[i].country !== arr[i - 1].country && (
                        <h2>{booth.country}</h2>
                      )}
                      <div
                        className="item-holder"
                        data-src={`https://travproconnect.com/profile/${booth.id}`}
                        data-type="iframe"
                        data-fancybox={booth.id}
                        dataOptions={JSON.stringify(fancyOptions)}
                        data-fancybox-trigger={booth.id}
                      >
                        <img
                          className="logo"
                          src={`${booth.icon.replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=200`}
                          alt={booth.propertyName}
                        />
                        <img
                          src={`${booth.headerImages[0].replace(
                            'tradecdn.travpromobile.com',
                            'tradecdn.imgix.net'
                          )}?width=300`}
                          alt={booth.propertyName}
                        />
                        <div className="content">{booth.propertyName}</div>
                        <div className="view">View Showcase &gt;</div>
                        <div className="clear" />
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
